import './Divider.scss';

export function Divider() {
    return <hr className="divider" />;
}
